export default __webpack_public_path__ + "static/media/instruction_step_1.08cb91c1.png";